import React from "react";
import { Link } from "react-router-dom";
import { ExternalLink, Sparkles, Mail, MessageSquare } from "lucide-react";
import PageBlocks from "@/components/site/PageBlocks";
import PageHeader from "@/components/site/PageHeader";
import EditableText from "@/components/site/EditableText";

export default function Rejoindre() {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 py-12">
      <PageHeader slug="rejoindre" fallbackTitle="Rejoindre le [mouvement](pink)" fallbackSubtitle="Tu veux faire bouger les choses ? Le CEF est l'organisation officielle qui défend les droits des élèves francophones. Adhère, participe, propose tes idées." />

      <PageBlocks slug="rejoindre" className="mt-6" />

      <section className="mt-8 neo-card p-6 sm:p-8 bg-cef-pink text-white" data-testid="join-site-cta">
        <div className="chip bg-white text-black mb-4"><Sparkles className="w-3.5 h-3.5 mr-1" /> Créer mon compte</div>
        <h2 className="font-display font-black text-2xl sm:text-3xl tracking-tighter uppercase leading-tight">Rejoindre le mouvement, c'est ici</h2>
        <EditableText slug="rejoindre" sectionKey="signup-cta-body" className="mt-3 text-base [&_p]:m-0">
          <p>Crée ton compte gratuit en 30 secondes pour voter sur les réformes, participer aux actions, témoigner et débloquer des badges. Pas besoin d'être membre officiel du CEF.</p>
        </EditableText>
        <div className="mt-5 flex flex-wrap gap-3">
          <Link to="/signup" className="neo-btn bg-white text-black text-base" data-testid="rejoindre-signup-cta">
            Créer mon compte
          </Link>
          <Link to="/login" className="neo-btn bg-cef-yellow text-black text-base" data-testid="rejoindre-login-cta">
            J'ai déjà un compte
          </Link>
        </div>
      </section>

      <section className="mt-6 neo-card p-6 bg-cef-yellow" data-testid="join-cef-cta">
        <div className="chip bg-black text-white mb-3"><Sparkles className="w-3.5 h-3.5 mr-1" /> Adhère au CEF officiel</div>
        <h3 className="font-display font-black text-xl tracking-tighter uppercase">Devenir membre officiel du CEF</h3>
        <EditableText slug="rejoindre" sectionKey="cef-cta-body" className="mt-2 text-sm [&_p]:m-0">
          <p>L'adhésion officielle se fait sur le site du CEF. Tu y trouveras toutes les modalités, l'agenda et l'équipe.</p>
        </EditableText>
        <a
          href="https://lecef.org/"
          target="_blank"
          rel="noopener noreferrer"
          className="mt-3 inline-flex items-center neo-btn bg-black text-white text-sm py-2"
          data-testid="rejoindre-external-link"
        >
          Adhérer sur lecef.org <ExternalLink className="w-4 h-4 ml-1" />
        </a>
      </section>

      <section className="mt-8 grid sm:grid-cols-2 gap-4">
        <div className="neo-card p-6 bg-white">
          <Mail className="w-6 h-6" strokeWidth={2.5} />
          <h3 className="mt-2 font-display font-black text-lg tracking-tight uppercase">Contact direct</h3>
          <EditableText slug="rejoindre" sectionKey="contact-body" className="mt-2 text-sm text-neutral-700 [&_p]:m-0">
            <p>Une question, une suggestion ? Écris-nous à <a href="mailto:info@lecef.org" className="font-bold underline">info@lecef.org</a></p>
          </EditableText>
        </div>
        <div className="neo-card p-6 bg-white">
          <MessageSquare className="w-6 h-6" strokeWidth={2.5} />
          <h3 className="mt-2 font-display font-black text-lg tracking-tight uppercase">Participe maintenant</h3>
          <EditableText slug="rejoindre" sectionKey="participate-body" className="mt-2 text-sm text-neutral-700 [&_p]:m-0">
            <p>Tu n'es pas obligé·e d'être membre pour faire entendre ta voix. Vote, témoigne, partage.</p>
          </EditableText>
          <Link to="/donner-mon-avis" className="mt-3 inline-flex neo-btn bg-cef-blue text-white text-sm py-2" data-testid="rejoindre-avis-cta">Donner mon avis</Link>
        </div>
      </section>
    </div>
  );
}
